/* eslint-disable arrow-body-style */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Card, Checkbox, Grid, makeStyles, Typography, withStyles,
} from '@material-ui/core';

import { authUserAction, authUserInfo } from '../../actions/loginActions';
import { GetCourseByUser, GetTopicById } from '../../services/courses';
import ReturnButton from '../General/ReturnButton';

import PanelStatistics from './PanelStatistics';
import SkeletonStatistics from './SkeletonStatistics';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      backgroundColor: theme.palette.background.primary,
      borderRadius: '10px',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.background.secondary,
      borderRadius: '10px',
    },
  },
  view: {
    padding: theme.spacing(5, 5),
  },
  container: {
    paddingTop: '2%',
    paddingLeft: '9%',
    paddingRight: '9%',
  },
  statisticsSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(0, 0, 6, 0),
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    background: theme.palette.background.card,
    color: theme.palette.common.white,
    padding: theme.spacing(2, 4),
    margin: theme.spacing(2, 0),
    cursor: 'pointer',
  },
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
    marginLeft: theme.spacing(3),
    fontFamily: 'Raleway',
    fontSize: '14px',
  },
  text: {
    fontFamily: 'Raleway',
    fontSize: '14px',
  },
  statistics: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    background: 'transparent',
    minWidth: 516,
    minHeight: 132,
    border: '5px solid',
    borderColor: '#21456E',
    borderRadius: '10px',
    color: theme.palette.text.default,
  },
  textStatistics: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleCourse: {
    fontFamily: 'Raleway',
    fontSize: '20px',
    fontWeight: 500,
    color: theme.palette.text.default,
    marginBottom: theme.spacing(2),
  },
  contentAvance: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textItemStatistics: {
    color: theme.palette.background.info,
    fontSize: '35px',
    fontFamily: 'Raleway',
  },
  cardDisabled: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: theme.palette.common.white,
    padding: theme.spacing(2, 4),
    margin: theme.spacing(2, 0),
    background: '#ff99991f',
  },
}));

const CheckboxCustom = withStyles((theme) => ({
  root: {
    color: theme.palette.background.info,
    '&$checked': {
      color: theme.palette.background.info,
    },
  },
  checked: {},
}))((props) => <Checkbox color="default" {...props} />);

function Statistics() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { topic, course } = location.state;

  const [lessonsList, setLessonsList] = useState([]);
  const [dataLesson, setDataLesson] = useState('');
  const [dataCouse, setDataCourse] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [finishedLessonsByUser, setFinishedLessonsByUser] = useState(0);
  const [practicalCase, setPracticalCase] = useState([]);
  const [quizz, setQuizz] = useState([]);

  const apiGetCourseByUser = async () => {
    setIsLoading(true);
    dispatch(authUserAction(sessionStorage.getItem('sub')));
    dispatch(authUserInfo(JSON.parse(sessionStorage.getItem('infoUser'))));
    const courseByUser = await GetCourseByUser(
      sessionStorage.getItem('sub'),
      course,
    );
    setDataCourse(courseByUser.data[0]);

    const topicById = await GetTopicById(topic);
    setDataLesson(topicById.data);

    const lessonsTopic = topicById.data.lessons;
    const { topicsByUser } = courseByUser.data[0];
    const topicSelected = topicsByUser.find((e) => e.idTopic === topic);
    setPracticalCase(topicSelected.practicalCaseByUser);

    setQuizz(topicSelected.quizByUser);

    const orderLessons = topicSelected.lessonsByUser.sort((a, b) => a.createdAt - b.createdAt);
    let lessons = orderLessons.map((e) => {
      const {
        id, completedLesson, createdAt, idLesson, idTopic, idUser, name,
      } = e;
      return {
        id,
        nameCourse: topicSelected.name,
        completedLesson,
        createdAt,
        idLesson,
        idTopic,
        idUser,
        name,
        idTopicUser: topicSelected.id,
        duration: lessonsTopic.find((i) => i.id === idLesson).duration,
      };
    });
    const finishedLessons = lessons.filter((lesson) => lesson.completedLesson);
    setLessonsList(lessons);
    setFinishedLessonsByUser(finishedLessons.length);
    setIsLoading(false);
  };

  const routeStatesWithPracticalOrQuizz = lessonsList.map((lesson) => {
    if (practicalCase.length !== 0 && quizz.length === 0) {
      return (
        <Link
          style={{ textDecoration: 'none' }}
          to="/lesson"
          state={
        {
          finalProjectUserId: dataCouse.finalProjectByUser.id,
          practicalId: practicalCase[0].id,
          practicalStatus: practicalCase[0].status,
          course,
          nameCourse: lesson.nameCourse,
          topic,
          idLessonUser: lesson.id,
          lessonId: lesson.idLesson,
          completedLesson: lesson.completedLesson,
          idUser: lesson.idUser,
          idTopicUser: lesson.idTopicUser,
          nameTopic: lesson.name,
        }
      }
          key={lesson.id}
        >
          <Card className={classes.card}>
            <CheckboxCustom checked={lesson.completedLesson === true} />
            <Typography className={classes.title}>{lesson.name}</Typography>
            <Typography className={classes.text}>
              {`${lesson.duration} minutos`}
            </Typography>
          </Card>
        </Link>
      );
    }
    if (quizz.length !== 0 && practicalCase.length === 0) {
      return (
        <Link
          style={{ textDecoration: 'none' }}
          to="/lesson"
          state={
        {
          finalProjectUserId: dataCouse.finalProjectByUser.id,
          quizzId: quizz[0].id,
          quizzStatus: quizz[0].status,
          course,
          nameCourse: lesson.nameCourse,
          topic,
          idLessonUser: lesson.id,
          lessonId: lesson.idLesson,
          completedLesson: lesson.completedLesson,
          idUser: lesson.idUser,
          idTopicUser: lesson.idTopicUser,
        }
      }
          key={lesson.id}
        >
          <Card className={classes.card}>
            <CheckboxCustom checked={lesson.completedLesson === true} />
            <Typography className={classes.title}>{lesson.name}</Typography>
            <Typography className={classes.text}>
              {`${lesson.duration} minutos`}
            </Typography>
          </Card>
        </Link>
      );
    }
    if (practicalCase.length !== 0 && quizz.length !== 0) {
      return (
        <Link
          style={{ textDecoration: 'none' }}
          to="/lesson"
          state={
        {
          finalProjectUserId: dataCouse.finalProjectByUser.id,
          quizzId: quizz[0].id,
          practicalId: practicalCase[0].id,
          practicalStatus: practicalCase[0].status,
          quizzStatus: quizz[0].status,
          course,
          nameCourse: lesson.nameCourse,
          topic,
          idLessonUser: lesson.id,
          lessonId: lesson.idLesson,
          completedLesson: lesson.completedLesson,
          idUser: lesson.idUser,
          idTopicUser: lesson.idTopicUser,
        }
      }
          key={lesson.id}
        >
          <Card className={classes.card}>
            <CheckboxCustom checked={lesson.completedLesson === true} />
            <Typography className={classes.title}>{lesson.name}</Typography>
            <Typography className={classes.text}>
              {`${lesson.duration} minutos`}
            </Typography>
          </Card>
        </Link>
      );
    }
    return (
      <Link
        style={{ textDecoration: 'none' }}
        to="/lesson"
        state={
        {
          finalProjectUserId: dataCouse.finalProjectByUser.id,
          course,
          nameCourse: lesson.nameCourse,
          topic,
          idLessonUser: lesson.id,
          lessonId: lesson.idLesson,
          completedLesson: lesson.completedLesson,
          idUser: lesson.idUser,
          idTopicUser: lesson.idTopicUser,
        }
      }
        key={lesson.id}
      >
        <Card className={classes.card}>
          <CheckboxCustom checked={lesson.completedLesson === true} />
          <Typography className={classes.title}>{lesson.name}</Typography>
          <Typography className={classes.text}>
            {`${lesson.duration} minutos`}
          </Typography>
        </Card>
      </Link>
    );
  });

  const navigateToEvaluation = () => {
    if (practicalCase.length === 0) {
      navigate('/quizz', {
        state: {
          quizzId: quizz[0].id,
          topic,
          course,
          finalProjectUserId: dataCouse.finalProjectByUser.id,
          idTopicUser: dataCouse.topicsByUser.find((e) => e.idTopic === topic).id,
          idUser: dataCouse.idUser,
          nameCourse: dataLesson.name,
        },
      });
    }
    navigate('/quizz', {
      state: {
        quizzId: quizz[0].id,
        topic,
        course,
        finalProjectUserId: dataCouse.finalProjectByUser.id,
        idTopicUser: dataCouse.topicsByUser.find((e) => e.idTopic === topic).id,
        idUser: dataCouse.idUser,
        practicalId: practicalCase[0].id,
        practicalStatus: practicalCase[0].status,
        practical: true,
        nameCourse: dataLesson.name,
      },
    });
  };

  const goToPracticalCaseView = () => {
    if (quizz.length === 0) {
      navigate('/lesson', {
        state: {
          topic,
          course,
          practicalId: practicalCase[0].id,
          practicalStatus: practicalCase[0].status,
          practical: true,
          nameCourse: dataLesson.name,
          idUser: dataCouse.idUser,
          finalProjectUserId: dataCouse.finalProjectByUser.id,
          idTopicUser: dataCouse.topicsByUser.find((e) => e.idTopic === topic).id,
        },
      });
    }
    navigate('/lesson', {
      state: {
        topic,
        course,
        practicalId: practicalCase[0].id,
        practicalStatus: practicalCase[0].status,
        quizzId: quizz[0].id,
        quizzStatus: quizz[0].status,
        practical: true,
        nameCourse: dataLesson.name,
        idUser: dataCouse.idUser,
        finalProjectUserId: dataCouse.finalProjectByUser.id,
        idTopicUser: dataCouse.topicsByUser.find((e) => e.idTopic === topic).id,
      },
    });
  };

  useEffect(() => {
    apiGetCourseByUser();
  }, []);

  return (
    <Grid
      className={classes.view}
      container
      direction="column"
      justifyContent="center"
      alignItems="stretch"
    >
      <Grid item>
        <ReturnButton />
      </Grid>
      {
        isLoading
          ? <SkeletonStatistics />
          : (
            <Grid
              className={classes.container}
              container
              direction="column"
              justifyContent="center"
              alignItems="stretch"
            >
              <Grid item className={classes.statisticsSection}>
                <PanelStatistics
                  numberFinishedLessons={finishedLessonsByUser}
                  totalLessons={lessonsList.length}
                  numberPracticalCase={practicalCase}
                  numberQuizz={quizz}
                />
              </Grid>
              <Grid item>
                <Typography className={classes.titleCourse}>{dataLesson.name}</Typography>
                <Box className={classes.root}>
                  {routeStatesWithPracticalOrQuizz}
                  {practicalCase.length !== 0
                    ? (
                      <Card className={practicalCase[0].status === true ? classes.card : classes.cardDisabled} onClick={practicalCase[0].status ? goToPracticalCaseView : null}>
                        <CheckboxCustom checked={practicalCase[0].file !== undefined} disabled={practicalCase[0].file === undefined} />
                        <Typography className={classes.title}>Caso Práctico</Typography>
                      </Card>
                    ) : null}
                  {quizz.length !== 0 ? (
                    <Card onClick={quizz[0].status === true ? navigateToEvaluation : null} className={quizz[0].status === true ? classes.card : classes.cardDisabled}>
                      <CheckboxCustom checked={quizz[0].score !== undefined} disabled={quizz[0].score === undefined} />
                      <Typography className={classes.title}>Evaluación</Typography>
                    </Card>
                  ) : null }
                </Box>
              </Grid>
            </Grid>
          )
      }
    </Grid>
  );
}

export default Statistics;
